import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import SortIcon from '@material-ui/icons/Sort';
import Typography from '@material-ui/core/Typography';

import './Filter.scss';

const Filter = ({
  setSortBy,
  sortBy,
  sortByOptions,
}) => (
  <div className="filter">
    <SortIcon />
    <div className="filter__label">
      <Typography>
        Sort by:
      </Typography>
    </div>
    <Select
      value={sortBy}
      onChange={setSortBy}
    >
      {sortByOptions.map(({
        id,
        name,
        value,
      }) => (
        <MenuItem
          key={id}
          value={value}
        >
          {name}
        </MenuItem>
      ))}
    </Select>
  </div>
);

Filter.propTypes = {
  sortBy: PropTypes.string.isRequired,
  sortByOptions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  setSortBy: PropTypes.func.isRequired,
};

export default Filter;



// WEBPACK FOOTER //
// ./src/common/components/Filter/Filter.js